import {useFormik} from "formik";
import {useEffect} from "react";
import ModalTemplate from "../../components/ModalTemplate/ModalTemplate";
import Input from "../../components/Input/Input";
import Button from "../../components/Button/Button";
import * as yup from "yup";
import Checkbox from "../../components/Checkbox/Checkbox"
import classNames from "classnames";
import {plusIcon} from "../../components/Icon/Icon";

const validationSchema = yup.object({
        name: yup.string().required("Form name is required."),
    }
);

const FormModal = ({ onClose, onSubmit, form }) => {
    const formik = useFormik({
        initialValues: {
            id: form?.id,
            name: form?.name,
            requiresSignature: form?.requiresSignature ?? false
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSubmit(values);
        },
    });

    const footerActions = (
        <>
            <Button type="submit" form="formModalForm" variant="primary">
                Save
            </Button>
            <Button type="button" onClick={onClose} variant="secondary">
                Cancel
            </Button>
        </>
    );

    return (
        <ModalTemplate
            onClose={onClose}
            title={formik.values.id ? 'Create form' : 'Edit form'}
            icon={plusIcon}
            footerActions={footerActions}
        >
            <form id="formModalForm" onSubmit={formik.handleSubmit}>
                <Input
                    name="name"
                    label="Name"
                    formik={formik}
                    className="modal"
                />
                <Checkbox
                    label="Requires signature"
                    name="requiresSignature"
                    variant={classNames("checkmark", "dark")}
                    formik={formik}
                />
            </form>
        </ModalTemplate>
    );
}

export default FormModal;